<template>
    <div>
      <design-renewal-report-list></design-renewal-report-list>
    </div>
  </template>
  <script>
  export default {
  }
  </script>
  